import {buildSelectOptions, removeTableRow} from "./shared";

//Cash for Destruction
export function addCashForDestructionRow(data) {
    $('#addCashForDestructionBtn').on('click', function (e) {
        e.preventDefault();
        $('#prepareCashForDestructionTable > tbody').append(cashForDestructionRow(data));
        removeTableRow();
    })
    $('#addMutilatedCashForDestructionBtn').on('click', function (e) {
        e.preventDefault();
        $('#prepareMutilatedCashForDestructionTable > tbody').append(mutilatedCashForDestructionRow(data));
        removeTableRow();
    })
}

export function cashForDestructionRow(data, removable=true) {
    let btnStr = '<th><button class="btn btn-sm btn-danger remove-btn" type="button">Remove</button></th>';
    if (!removable) {
        btnStr = '<th><button class="btn btn-sm btn-danger" type="button">Remove</button></th>';
    }
    return `
        <tr>
             <td>
                 <select name="denom" class="form-control form-control-sm" required>
                    <option value="">Choose...</option>
                    ${buildSelectOptions(data)}
                 </select>
             </td>
             <td>
                 <input type="number" min="1" step="1" name="denomCount" required value="1" class="form-control form-control-sm">
             </td>
             <td>
                 <select name="cashCondition" class="form-select form-select-sm" required>
                    <option value="">Choose...</option>
                    <option value="MIXED">MIXED</option>
                    <option value="FIT">FIT</option>
                    <option value="SOILED">SOILED</option>
                 </select>
             </td>
             <th>
                ${btnStr}
             </th>
        </tr>`;

}

export function mutilatedCashForDestructionRow(data, removable=true) {
    let btnStr = '<th><button class="btn btn-sm btn-danger remove-btn" type="button">Remove</button></th>';
    if (!removable) {
        btnStr = '<th><button class="btn btn-sm btn-danger" type="button">Remove</button></th>';
    }
    return `
        <tr>
             <td>
                 <select name="mutilatedDenom" class="form-control form-control-sm" required>
                    <option value="">Choose...</option>
                    ${buildSelectOptions(data)}
                 </select>
             </td>
             <td>
                 <input type="number" min="1" step="1" name="mutilatedDenomCount" required value="1" class="form-control form-control-sm">
             </td>
             <td>
                 <select name="mutilationCategory" class="form-select form-select-sm" required>
                    <option value="">Choose...</option>
                    <option value="FULL">FULL</option>
                    <option value="HALF">HALF</option>
                    <option value="ZERO">ZERO</option>
                 </select>
             </td>
             <th>
                ${btnStr}
             </th>
        </tr>`;

}

export function redoCashForDestructionTable(data) {
    var elem = $('#prepareCashForDestructionTable > tbody');
    elem.empty();
    elem.append(cashForDestructionRow(data, false));
}
